import { IconButton, Tooltip } from "@chakra-ui/react";
import { Select, Trans, t } from "@lingui/macro";
import type { FieldState } from "formstate";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import { Icon } from "./Icon";

type Props = {
  field: FieldState<boolean>;
  size?: "md" | "lg";
  isDisabled?: boolean;
};

export const BillableButton: FunctionComponent<Props> = observer(
  function BillableButton({ field, size = "md", isDisabled }) {
    const iconSize = size === "lg" ? "7" : undefined;

    return (
      <Tooltip
        label={
          <Trans>
            Time entry is{" "}
            <Select
              value={field.value ? "billable" : "nonBillable"}
              _billable="billable"
              _nonBillable="non-billable"
              other="billable"
            />
            . Click to change to{" "}
            <Select
              value={field.value ? "nonBillable" : "billable"}
              _billable="billable"
              _nonBillable="non-billable"
              other="billable"
            />
            .
          </Trans>
        }
        placement="top"
        shouldWrapChildren
      >
        <IconButton
          aria-label={t`Tracking item billability switch`}
          icon={
            field.value ? (
              <Icon name="billable" w={iconSize} h={iconSize} />
            ) : (
              <Icon name="non-billable" w={iconSize} h={iconSize} />
            )
          }
          isDisabled={isDisabled}
          onClick={() => {
            field.onChange(!field.$);
          }}
          size={size}
          variant="ghost"
        />
      </Tooltip>
    );
  },
);
